import type { FC } from 'react'
import { useCartState } from '@components/cart/State/state'
import { useTranslate } from '@hooks/useTranslation'
import { CwsDivider, CwsRadio, CwsP } from '@components/cws'
import EstoOptions from '@components/cart/payment/PaymentMethods/EstoOptions'
import { useRouter } from 'next/router'
import { isBankEnabled } from '@utils/isBankEnabled'

export const PaymentVariant: FC = () => {
  const { translate } = useTranslate()
  const { locale } = useRouter()
  const {
    dispatch,
    state: { paymentMethod },
  } = useCartState()
  const isSwedish = locale === 'sv'
  const isBank = isBankEnabled()

  return (
    <>
      {!isSwedish && isBank && (
        <>
          <CwsRadio
            label={translate('cart.payment.online.label')}
            checked={paymentMethod === 'banks'}
            value={paymentMethod}
            onClick={() => {
              dispatch({ type: 'setPaymentMethod', payload: 'banks' })
              dispatch({
                type: 'setPaymentTypeDetails',
                payload: '',
              })
            }}
          >
            {translate('cart.payment.online.label')}
          </CwsRadio>
          <CwsP size="small" className="cws-pl-32 cws-ml-2">
            {translate('cart.payment.online.description')}
          </CwsP>
          <CwsDivider className="cws-mx-0" />
        </>
      )}

      <CwsRadio
        label={translate('cart.payment.creditcard.label')}
        checked={paymentMethod === 'dibs'}
        value={paymentMethod}
        onClick={() => {
          dispatch({ type: 'setPaymentMethod', payload: 'dibs' })
          dispatch({
            type: 'setPaymentTypeDetails',
            payload: '',
          })
        }}
      >
        {translate('cart.payment.creditcard.label')}
      </CwsRadio>
      <CwsP size="small" className="cws-pl-32 cws-ml-2">
        {translate('cart.payment.dibs.help')}
      </CwsP>
      <CwsDivider className="cws-mx-0" />
      {isSwedish && (
        <>
          <CwsRadio
            label={translate('cart.payment.klarna.label')}
            checked={paymentMethod === 'klarna'}
            value={paymentMethod}
            onClick={() => {
              dispatch({ type: 'setPaymentMethod', payload: 'klarna' })
              dispatch({
                type: 'setPaymentTypeDetails',
                payload: '',
              })
            }}
          >
            {translate('cart.payment.klarna.label')}
          </CwsRadio>
          <CwsP
            size="small"
            className="cws-pl-32 cws-ml-2"
            dangerouslySetInnerHTML={{ __html: translate('cart.payment.klarna.help') }}
          />
        </>
      )}
      {!isSwedish && <EstoOptions />}
    </>
  )
}
